// assets/components/WizLoadingCircle.jsx
import React from "react";
import wiz from "../../assets/image/auto/wiz.svg";
import "../../styles/loading.css";

const WizLoadingCircle = ({
  size = 180,      // 원 기본 지름
  logoHeight = 40, // 가운데 로고 높이
  progress = 0,    // 이제 안 써도 되지만, 외부 API 맞추려고 놔둠
}) => {
  return (
    <div className="mb-8">
      {/* 바깥 래퍼는 여유 있게 200px 정도로 잡아서 스케일업 시 안 잘리게 */}
      <div
        className="relative flex items-center justify-center"
        style={{ width: 200, height: 200 }}
      >
        {/* 실제로 커졌다 작아질 원 */}
        <div
          className="wiz-pulse-circle rounded-full bg-surface-light-primary-light flex items-center justify-center"
          style={{ width: size, height: size }} // 기본 180px → 애니메이션으로 대략 200px까지
        >
          {/* 가운데 wiz 로고 */}
          <span className="relative z-10 tracking-tight">
            <img src={wiz} alt="wiz" style={{ height: logoHeight }} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default WizLoadingCircle;
